import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { int32_type, bool_type, unit_type, record_type, option_type, list_type, class_type, lambda_type, union_type, tuple_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { DomainEntities__ToPluralString, DomainEntities_$reflection } from "../DomainEvents.fs.js";
import { DomainEntity_$reflection } from "../ClientTypes.fs.js";
import { isEmpty, mapIndexed, tryHead, filter as filter_3, tryItem, indexed, partition, singleton, empty, map as map_1, cons, append, ofArray, ofSeq, length } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { iterate, empty as empty_3, singleton as singleton_1, append as append_1, delay as delay_1, toList, choose, map } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { equals, uncurry2, createObj, comparePrimitives, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { ofSeq as ofSeq_1, FSharpSet__get_Count, union, filter as filter_1, FSharpSet__Contains, empty as empty_1, ofList } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { FSharpMap__TryFind, toList as toList_1, tryFind, empty as empty_2, filter as filter_2, add, fold, ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { Cmd_OfPromise_perform, Cmd_none } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { System_Int32__Int32_tryParse_Static_Z721C83C5, System_Int32__Int32_ToLocaleString, Thoth_Fetch_FetchError__FetchError_get_Message } from "../Prelude.fs.js";
import { toArray, map as map_2, defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createElement } from "react";
import React from "react";
import { useFeliz_React__React_useDebouncer_Static } from "../hooks/UseDebouncer.fs.js";
import { Helpers_extractClasses, Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { useFeliz_React__React_useFetch_Static_6ADA66EC, Fetched$1_toOption_50D43789 } from "../hooks/UseFetch.fs.js";
import { labels as labels_1 } from "../Api/Tags.fs.js";
import { labels as labels_2 } from "../Api/Actions.fs.js";
import { labels as labels_3 } from "../Api/Documents.fs.js";
import { labels as labels_4 } from "../Api/Activities.fs.js";
import { labels as labels_5 } from "../Api/Facilities.fs.js";
import { labels as labels_6 } from "../Api/Modules.fs.js";
import { labels as labels_7 } from "../Api/Areas.fs.js";
import { labels as labels_8 } from "../Api/Locations.fs.js";
import { labels as labels_9 } from "../Api/ProductionUnits.fs.js";
import { labels as labels_10 } from "../Api/Systems.fs.js";
import { labels as labels_11 } from "../Api/Subsystems.fs.js";
import { SelectGroup, SelectOption, SelectItem, selectSearch_options_113CE11B, selectSearch_filterOptions_Z7A2530AD } from "../fable_modules/Feliz.SelectSearch.3.1.0/SelectSearch.fs.js";
import { join, split as split_1, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { item as item_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { reactApi } from "../fable_modules/Feliz.SelectSearch.3.1.0/../Feliz.2.9.0/Interop.fs.js";
import react_select_search from "react-select-search";
import { Interop_defaultProps } from "../fable_modules/Feliz.SelectSearch.3.1.0/./SelectSearch.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { DomainEntitySelector } from "../components/EntitySelector.fs.js";
import { fromString } from "../hooks/../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { toString } from "../hooks/../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/./UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Feliz.UseElmish.2.5.0/../Fable.Elmish.4.2.0/program.fs.js";
import { max, min } from "../fable_modules/fable-library-js.4.24.0/Double.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";
import { Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";

export class FilterType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["String", "Entity", "Label"];
    }
}

export function FilterType_$reflection() {
    return union_type("EPM.App.Admin.Table.FilterType", [], FilterType, () => [[["Item", lambda_type(string_type, union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(string_type, string_type), string_type], FSharpResult$2, () => [[["ResultValue", tuple_type(string_type, string_type)]], [["ErrorValue", string_type]]]))]], [["Item1", class_type("System.Guid")], ["Item2", DomainEntities_$reflection()], ["Item3", list_type(tuple_type(string_type, string_type))], ["Item4", lambda_type(option_type(DomainEntity_$reflection()), union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(string_type, string_type), string_type], FSharpResult$2, () => [[["ResultValue", tuple_type(string_type, string_type)]], [["ErrorValue", string_type]]]))]], [["Item1", class_type("System.Guid")], ["Item2", DomainEntities_$reflection()], ["Item3", list_type(tuple_type(string_type, string_type))], ["Item4", lambda_type(tuple_type(string_type, string_type), union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(string_type, string_type), string_type], FSharpResult$2, () => [[["ResultValue", tuple_type(string_type, string_type)]], [["ErrorValue", string_type]]]))]]]);
}

export class Cell extends Record {
    constructor(Id, Render) {
        super();
        this.Id = Id;
        this.Render = Render;
    }
}

export function Cell_$reflection() {
    return record_type("EPM.App.Admin.Table.Cell", [], Cell, () => [["Id", string_type], ["Render", class_type("Fable.React.ReactElement", undefined)]]);
}

export class Column extends Record {
    constructor(Id, Name, Filter) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Filter = Filter;
    }
}

export function Column_$reflection() {
    return record_type("EPM.App.Admin.Table.Column", [], Column, () => [["Id", string_type], ["Name", string_type], ["Filter", option_type(FilterType_$reflection())]]);
}

export class Row extends Record {
    constructor(Id, Cells) {
        super();
        this.Id = Id;
        this.Cells = Cells;
    }
}

export function Row_$reflection() {
    return record_type("EPM.App.Admin.Table.Row", [], Row, () => [["Id", class_type("System.Guid")], ["Cells", list_type(Cell_$reflection())]]);
}

export class RowSelection$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["None", "Single", "Multiple"];
    }
}

export function RowSelection$1_$reflection(gen0) {
    return union_type("EPM.App.Admin.Table.RowSelection`1", [gen0], RowSelection$1, () => [[], [["Item", lambda_type(option_type(gen0), unit_type)]], [["Item", lambda_type(list_type(gen0), unit_type)]]]);
}

class State$1 extends Record {
    constructor(IsLoading, IsTotalLoading, Total, Filters, InitialFilterKeys, Offset, Fetch, Data, SelectedIndex) {
        super();
        this.IsLoading = IsLoading;
        this.IsTotalLoading = IsTotalLoading;
        this.Total = (Total | 0);
        this.Filters = Filters;
        this.InitialFilterKeys = InitialFilterKeys;
        this.Offset = (Offset | 0);
        this.Fetch = (Fetch | 0);
        this.Data = Data;
        this.SelectedIndex = SelectedIndex;
    }
}

function State$1_$reflection(gen0) {
    return record_type("EPM.App.Admin.Table.State`1", [gen0], State$1, () => [["IsLoading", bool_type], ["IsTotalLoading", bool_type], ["Total", int32_type], ["Filters", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["InitialFilterKeys", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])], ["Offset", int32_type], ["Fetch", int32_type], ["Data", list_type(gen0)], ["SelectedIndex", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [int32_type])]]);
}

function State$1__get_CanFirst(this$) {
    return this$.Offset > 0;
}

function State$1__get_CanPrevious(this$) {
    return this$.Offset > 0;
}

function State$1__get_CanNext(this$) {
    return (this$.Offset + length(this$.Data)) < this$.Total;
}

function State$1__get_CanLast(this$) {
    return (this$.Offset + length(this$.Data)) < this$.Total;
}

class Msg$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ChangeFilter", "MergeInitialFilters", "LoadNewPage", "LoadFirstPage", "LoadNextPage", "LoadPreviousPage", "LoadLastPage", "FirstPageLoaded", "PageLoaded", "LoadError", "SelectSingle", "SelectMultiple", "SelectAll", "NotifyExternalSelection"];
    }
}

function Msg$1_$reflection(gen0) {
    return union_type("EPM.App.Admin.Table.Msg`1", [gen0], Msg$1, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(string_type, string_type), string_type], FSharpResult$2, () => [[["ResultValue", tuple_type(string_type, string_type)]], [["ErrorValue", string_type]]])]], [["Item", list_type(tuple_type(string_type, string_type))]], [], [], [], [], [], [["Item1", int32_type], ["Item2", list_type(gen0)]], [["Item", list_type(gen0)]], [["Item", FetchError_$reflection()]], [["Item", int32_type]], [["Item", list_type(int32_type)]], [], []]);
}

function filtersToApiParams(filters) {
    return ofSeq(map((kv) => [kv[0], kv[1]], filters));
}

function loadPage(loadData, fetch$, offset, filtersMap) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const extraFilters = ofArray([["fetch", int32ToString(fetch$)], ["offset", int32ToString(offset)]]);
        const filters = filtersToApiParams(filtersMap);
        return loadData(append(filters, extraFilters)).then((_arg) => {
            const response = _arg;
            return (response.tag === 1) ? (Promise.resolve(new Msg$1(9, [response.fields[0]]))) : (Promise.resolve(new Msg$1(8, [response.fields[0]])));
        });
    }));
}

function loadPageAndCount(loadData, loadCount, fetch$, filtersMap) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const extraFilters = ["fetch", int32ToString(fetch$)];
        const filters = filtersToApiParams(filtersMap);
        return (Promise.all([loadCount(filters), loadData(cons(extraFilters, filters))])).then((_arg) => {
            let copyOfStruct, copyOfStruct_1;
            return Promise.resolve((copyOfStruct = _arg[0], (copyOfStruct.tag === 1) ? (new Msg$1(9, [copyOfStruct.fields[0]])) : ((copyOfStruct_1 = _arg[1], (copyOfStruct_1.tag === 1) ? (new Msg$1(9, [copyOfStruct_1.fields[0]])) : (new Msg$1(7, [copyOfStruct.fields[0], copyOfStruct_1.fields[0]]))))));
        });
    }));
}

function init(filters, fetch$) {
    const filterKeys = ofList(map_1((tuple) => tuple[0], filters), {
        Compare: comparePrimitives,
    });
    return [new State$1(false, false, 0, ofList_1(filters, {
        Compare: comparePrimitives,
    }), filterKeys, 0, fetch$, empty(), empty_1({
        Compare: comparePrimitives,
    })), singleton((dispatch) => {
        dispatch(new Msg$1(2, []));
    })];
}

function update(fetchData, fetchCount, rowSelection, onFiltersChange, msg, state) {
    let set$_2;
    switch (msg.tag) {
        case 11: {
            const patternInput = partition((e) => FSharpSet__Contains(state.SelectedIndex, e), msg.fields[0]);
            const removeIds = ofList(patternInput[0], {
                Compare: comparePrimitives,
            });
            return [new State$1(state.IsLoading, state.IsTotalLoading, state.Total, state.Filters, state.InitialFilterKeys, state.Offset, state.Fetch, state.Data, (set$_2 = filter_1((arg) => !FSharpSet__Contains(removeIds, arg), state.SelectedIndex), union(ofList(patternInput[1], {
                Compare: comparePrimitives,
            }), set$_2))), singleton((dispatch_1) => {
                dispatch_1(new Msg$1(13, []));
            })];
        }
        case 12:
            return [new State$1(state.IsLoading, state.IsTotalLoading, state.Total, state.Filters, state.InitialFilterKeys, state.Offset, state.Fetch, state.Data, ofList(map_1((tuple) => tuple[0], indexed(state.Data)), {
                Compare: comparePrimitives,
            })), singleton((dispatch_2) => {
                dispatch_2(new Msg$1(13, []));
            })];
        case 13: {
            rowSelection(ofSeq(choose((i) => tryItem(i, state.Data), state.SelectedIndex)));
            return [state, Cmd_none()];
        }
        case 1: {
            const newInitialFilters = msg.fields[0];
            const newInitialMap = ofList_1(newInitialFilters, {
                Compare: comparePrimitives,
            });
            const newInitialKeys = ofList(map_1((tuple_1) => tuple_1[0], newInitialFilters), {
                Compare: comparePrimitives,
            });
            const mergedFilters = fold((acc, key_1, value_3) => add(key_1, value_3, acc), filter_2((key, _arg) => !FSharpSet__Contains(state.InitialFilterKeys, key), state.Filters), newInitialMap);
            onFiltersChange(filtersToApiParams(mergedFilters));
            return [new State$1(state.IsLoading, state.IsTotalLoading, state.Total, mergedFilters, newInitialKeys, state.Offset, state.Fetch, state.Data, state.SelectedIndex), singleton((dispatch_3) => {
                dispatch_3(new Msg$1(2, []));
            })];
        }
        case 0: {
            const result = msg.fields[0];
            const filters = (result.tag === 1) ? filter_2((k, _arg_1) => (k !== result.fields[0]), state.Filters) : add(result.fields[0][0], result.fields[0][1], state.Filters);
            onFiltersChange(filtersToApiParams(filters));
            return [new State$1(state.IsLoading, state.IsTotalLoading, state.Total, filters, state.InitialFilterKeys, state.Offset, state.Fetch, state.Data, state.SelectedIndex), singleton((dispatch_4) => {
                dispatch_4(new Msg$1(2, []));
            })];
        }
        case 2:
            return [new State$1(true, true, 0, state.Filters, state.InitialFilterKeys, 0, state.Fetch, empty(), state.SelectedIndex), Cmd_OfPromise_perform(() => loadPageAndCount(fetchData, fetchCount, state.Fetch, state.Filters), undefined, (x_8) => x_8)];
        case 4:
            return [new State$1(true, state.IsTotalLoading, state.Total, state.Filters, state.InitialFilterKeys, state.Offset + state.Fetch, state.Fetch, state.Data, state.SelectedIndex), Cmd_OfPromise_perform(() => loadPage(fetchData, state.Fetch, state.Offset + state.Fetch, state.Filters), undefined, (x_9) => x_9)];
        case 5:
            return [new State$1(true, state.IsTotalLoading, state.Total, state.Filters, state.InitialFilterKeys, state.Offset - state.Fetch, state.Fetch, state.Data, state.SelectedIndex), Cmd_OfPromise_perform(() => loadPage(fetchData, state.Fetch, state.Offset - state.Fetch, state.Filters), undefined, (x_10) => x_10)];
        case 3:
            return [new State$1(true, state.IsTotalLoading, state.Total, state.Filters, state.InitialFilterKeys, 0, state.Fetch, state.Data, state.SelectedIndex), Cmd_OfPromise_perform(() => loadPage(fetchData, state.Fetch, 0, state.Filters), undefined, (x_11) => x_11)];
        case 6: {
            const offset = ((state.Total - state.Fetch) + (((state.Total % state.Fetch) > 0) ? state.Fetch : 0)) | 0;
            return [new State$1(true, state.IsTotalLoading, state.Total, state.Filters, state.InitialFilterKeys, offset, state.Fetch, state.Data, state.SelectedIndex), Cmd_OfPromise_perform(() => loadPage(fetchData, state.Fetch, offset, state.Filters), undefined, (x_12) => x_12)];
        }
        case 7:
            return [new State$1(false, false, msg.fields[0], state.Filters, state.InitialFilterKeys, state.Offset, state.Fetch, msg.fields[1], state.SelectedIndex), Cmd_none()];
        case 8:
            return [new State$1(false, state.IsTotalLoading, state.Total, state.Filters, state.InitialFilterKeys, state.Offset, state.Fetch, msg.fields[0], state.SelectedIndex), Cmd_none()];
        case 9: {
            const error = msg.fields[0];
            console.error(some(Thoth_Fetch_FetchError__FetchError_get_Message(error)), error);
            return [new State$1(false, state.IsTotalLoading, state.Total, state.Filters, state.InitialFilterKeys, state.Offset, state.Fetch, state.Data, state.SelectedIndex), Cmd_none()];
        }
        default: {
            const index = msg.fields[0] | 0;
            return [new State$1(state.IsLoading, state.IsTotalLoading, state.Total, state.Filters, state.InitialFilterKeys, state.Offset, state.Fetch, state.Data, (FSharpSet__get_Count(state.SelectedIndex) > 1) ? ofSeq_1([index], {
                Compare: comparePrimitives,
            }) : (FSharpSet__Contains(state.SelectedIndex, index) ? empty_1({
                Compare: comparePrimitives,
            }) : ofSeq_1([index], {
                Compare: comparePrimitives,
            }))), singleton((dispatch) => {
                dispatch(new Msg$1(13, []));
            })];
        }
    }
}

function StringFilter(stringFilterInputProps) {
    const onChange = stringFilterInputProps.onChange;
    const initialValue = stringFilterInputProps.initialValue;
    const patternInput = useFeliz_React__React_useDebouncer_Static(initialValue, onChange, 300);
    return createElement("input", createObj(cons(["type", "search"], Helpers_combineClasses("input", ofArray([["className", "is-small"], ["onChange", (ev) => {
        patternInput[1](ev.target.value);
    }], ["value", patternInput[0]]])))));
}

function LabelFilter(labelFilterInputProps) {
    const onChange = labelFilterInputProps.onChange;
    const filters = labelFilterInputProps.filters;
    const entity = labelFilterInputProps.entity;
    const projectId = labelFilterInputProps.projectId;
    const labelsOpt = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC(((entity.tag === 0) ? ((projectId_1) => ((tagParams) => labels_1(projectId_1, tagParams))) : ((entity.tag === 11) ? ((projectId_2) => ((actionParams) => labels_2(projectId_2, actionParams))) : ((entity.tag === 9) ? ((projectId_3) => ((documentParams) => labels_3(projectId_3, documentParams))) : ((entity.tag === 5) ? ((projectId_4) => ((activityParams) => labels_4(projectId_4, activityParams))) : ((entity.tag === 3) ? ((projectId_5) => ((facilityParams) => labels_5(projectId_5, facilityParams))) : ((entity.tag === 6) ? ((projectId_6) => ((moduleParams) => labels_6(projectId_6, moduleParams))) : ((entity.tag === 7) ? ((projectId_7) => ((areaParams) => labels_7(projectId_7, areaParams))) : ((entity.tag === 8) ? ((projectId_8) => ((locationParams) => labels_8(projectId_8, locationParams))) : ((entity.tag === 13) ? ((projectId_9) => ((productionUnitTypeParams) => labels_9(projectId_9, productionUnitTypeParams))) : ((entity.tag === 1) ? ((projectId_10) => ((systemParams) => labels_10(projectId_10, systemParams))) : ((entity.tag === 2) ? ((projectId_11) => ((subsystemParams) => labels_11(projectId_11, subsystemParams))) : ((console.warn(some(`${DomainEntities__ToPluralString(entity)} does not have a labels api`)), (_arg) => ((_arg_1) => {
        const a = new FSharpResult$2(0, [empty_2({
            Compare: comparePrimitives,
        })]);
        return Promise.resolve(a);
    }))))))))))))))(projectId), filters, []));
    if (labelsOpt != null) {
        const labels = labelsOpt;
        const inputProperties = createObj(ofArray([["placeholder", "Select Label"], ["search", true], selectSearch_filterOptions_Z7A2530AD((item, searchQuery) => (item.value.toLocaleLowerCase().indexOf(searchQuery.trim().toLocaleLowerCase()) >= 0)), ["onChange", (value) => {
            if (isNullOrWhiteSpace(value)) {
                onChange(["", ""]);
            }
            else {
                const split = split_1(value, ["⚓"], undefined, 0);
                if (split.length === 2) {
                    onChange([item_1(0, split), item_1(1, split)]);
                }
                else {
                    onChange(["", ""]);
                }
            }
        }], selectSearch_options_113CE11B(toList(delay_1(() => append_1(singleton_1(new SelectOption(0, [new SelectItem("", "-- None Selected --", false)])), delay_1(() => map((label) => (new SelectOption(1, [new SelectGroup(label[0], ofSeq(map((v) => (new SelectItem(`${label[0]}⚓${v}`, v, false)), label[1])))])), labels))))))]));
        return reactApi.createElement(react_select_search, Object.assign({}, Interop_defaultProps, inputProperties));
    }
    else {
        return defaultOf();
    }
}

function DomainEntityFilter(domainEntityFilterInputProps) {
    const dispatch = domainEntityFilterInputProps.dispatch;
    const onFilterChange = domainEntityFilterInputProps.onFilterChange;
    const filters = domainEntityFilterInputProps.filters;
    const entity = domainEntityFilterInputProps.entity;
    const projectId = domainEntityFilterInputProps.projectId;
    let onChange;
    const dependencies_1 = [dispatch, onFilterChange];
    onChange = reactApi_1.useCallback((arg_1) => {
        dispatch(new Msg$1(0, [onFilterChange(arg_1)]));
    }, dependencies_1);
    return createElement(DomainEntitySelector, {
        projectId: projectId,
        entityType: entity,
        onSelectedEntityChange: onChange,
        filters: filters,
        isSmall: true,
    });
}

function RenderFilter(renderFilterInputProps) {
    let elems;
    const dispatch = renderFilterInputProps.dispatch;
    const filter = renderFilterInputProps.filter;
    const currentFilters = renderFilterInputProps.currentFilters;
    const columnId = renderFilterInputProps.columnId;
    const key = renderFilterInputProps.$key;
    const currentValue = defaultArg(tryFind(columnId, currentFilters), "");
    return createElement("div", createObj(ofArray([["key", key], (elems = toList(delay_1(() => ((filter.tag === 1) ? singleton_1(createElement(DomainEntityFilter, {
        projectId: filter.fields[0],
        entity: filter.fields[1],
        filters: filter.fields[2],
        onFilterChange: filter.fields[3],
        dispatch: dispatch,
    })) : ((filter.tag === 2) ? singleton_1(createElement(LabelFilter, {
        projectId: filter.fields[0],
        entity: filter.fields[1],
        filters: filter.fields[2],
        onChange: (arg_3) => {
            dispatch(new Msg$1(0, [filter.fields[3](arg_3)]));
        },
    })) : singleton_1(createElement(StringFilter, {
        initialValue: currentValue,
        onChange: (arg_1) => {
            dispatch(new Msg$1(0, [filter.fields[0](arg_1)]));
        },
    })))))), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

const fetchOptions = ofArray([10, 25, 50, 100, 250, 500]);

export function Table(tableInputProps) {
    let key, initialValue, patternInput, elems_8, children_4, children_2, children_8, children_11, elems_7, elems_6, elms, patternInput_6, elems_3, elems_4;
    const rowSelection = tableInputProps.rowSelection;
    const refresh = tableInputProps.refresh;
    const rowRender = tableInputProps.rowRender;
    const fetchCount = tableInputProps.fetchCount;
    const fetchData = tableInputProps.fetchData;
    const onFiltersChange = tableInputProps.onFiltersChange;
    const initialFilters = tableInputProps.initialFilters;
    const columns = tableInputProps.columns;
    const name = tableInputProps.name;
    const columnVisbility = ((key = (`table.${name}`), (initialValue = empty_1({
        Compare: comparePrimitives,
    }), (patternInput = reactApi_1.useState(() => {
        const existingValue = window.localStorage.getItem(key);
        if (isNullOrWhiteSpace(existingValue)) {
            return initialValue;
        }
        else {
            const result = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type]), undefined, undefined)), existingValue);
            if (result.tag === 1) {
                console.error(some(`Unable to get ${key} from local storage`), result.fields[0]);
                return initialValue;
            }
            else {
                return result.fields[0];
            }
        }
    }), [patternInput[0], (value_1) => {
        const json = toString(4, Auto_generateBoxedEncoder_437914C6(class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type]), undefined, undefined, undefined)(value_1));
        window.localStorage.setItem(key, json);
        patternInput[1](value_1);
    }]))))[0];
    let patternInput_3;
    const key_1 = `table.${name}.fetchSize`;
    const patternInput_2 = reactApi_1.useState(() => {
        const existingValue_1 = window.localStorage.getItem(key_1);
        if (isNullOrWhiteSpace(existingValue_1)) {
            return 25;
        }
        else {
            const result_1 = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(int32_type, undefined, undefined)), existingValue_1);
            if (result_1.tag === 1) {
                console.error(some(`Unable to get ${key_1} from local storage`), result_1.fields[0]);
                return 25;
            }
            else {
                return result_1.fields[0] | 0;
            }
        }
    });
    patternInput_3 = [patternInput_2[0], (value_1_1) => {
        const json_1 = toString(4, Auto_generateBoxedEncoder_437914C6(int32_type, undefined, undefined, undefined)(value_1_1));
        window.localStorage.setItem(key_1, json_1);
        patternInput_2[1](value_1_1);
    }];
    const fetchSize = patternInput_3[0] | 0;
    const prevInitialFiltersRef = reactApi_1.useRef(initialFilters);
    const initialFiltersString = join("", map_1((tupledArg) => (tupledArg[0] + tupledArg[1]), initialFilters));
    const visbileColumns = filter_3((arg) => !FSharpSet__Contains(columnVisbility, arg), map_1((col) => col.Id, columns));
    const canClick = !(rowSelection.tag === 0);
    const canMultiClick = rowSelection.tag === 2;
    let prevFiltersRef;
    const initialValue_3 = ofList_1(initialFilters, {
        Compare: comparePrimitives,
    });
    prevFiltersRef = (reactApi_1.useRef(initialValue_3));
    const patternInput_4 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(toList_1(prevFiltersRef.current), fetchSize), (msg, state) => update(fetchData, fetchCount, (data) => {
        switch (rowSelection.tag) {
            case 1: {
                rowSelection.fields[0](tryHead(data));
                break;
            }
            case 2: {
                rowSelection.fields[0](data);
                break;
            }
            default:
                undefined;
        }
    }, onFiltersChange, msg, state), (_arg, _arg_1) => {
    }), undefined, [refresh, fetchSize]);
    const state_1 = patternInput_4[0];
    const dispatch = patternInput_4[1];
    const dependencies_2 = [state_1.Filters];
    reactApi_1.useEffect(() => {
        prevFiltersRef.current = state_1.Filters;
    }, dependencies_2);
    const dependencies_4 = [initialFiltersString];
    reactApi_1.useEffect(() => {
        if (!equals(prevInitialFiltersRef.current, initialFilters)) {
            prevInitialFiltersRef.current = initialFilters;
            dispatch(new Msg$1(1, [initialFilters]));
        }
    }, dependencies_4);
    const patternInput_5 = reactApi_1.useState(0);
    const lastIndex = patternInput_5[0] | 0;
    let onRowClick;
    const dependencies_1_1 = [canClick, canMultiClick, dispatch, lastIndex];
    onRowClick = reactApi_1.useCallback((event) => ((i) => {
        if (canMultiClick) {
            if (event.shiftKey) {
                const start = min(i, lastIndex) | 0;
                const endIndex = max(i, lastIndex) | 0;
                const indexToIgnore = ((i === start) ? endIndex : start) | 0;
                dispatch(new Msg$1(11, [filter_3((i_2) => (i_2 !== indexToIgnore), toList(delay_1(() => map((i_1) => i_1, rangeDouble(start, 1, endIndex)))))]));
            }
            else if (event.ctrlKey) {
                dispatch(new Msg$1(11, [singleton(i)]));
            }
            else {
                dispatch(new Msg$1(10, [i]));
            }
        }
        else {
            dispatch(new Msg$1(10, [i]));
        }
        patternInput_5[1](i);
    }), dependencies_1_1);
    let onRowDoubleClick;
    const dependencies_1_2 = [dispatch];
    onRowDoubleClick = reactApi_1.useCallback((_arg_2) => {
        dispatch(new Msg$1(12, []));
    }, dependencies_1_2);
    return createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "is-bordered"], ["className", "is-striped"], ["className", "is-narrow"], ["className", "is-hoverable"], ["className", "is-fullwidth"], (elems_8 = [(children_4 = singleton((children_2 = mapIndexed((i_3, col_2) => {
        const children = toList(delay_1(() => {
            let iconProps, elems_1, elems;
            return append_1((i_3 === 0) ? singleton_1((iconProps = ofArray([(elems_1 = [Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-columns"]), new Fa_IconOption(15, ["column-option"])]), [])], ["children", reactApi_1.Children.toArray(Array.from(elems_1))]), ["className", "is-clickable"], ["title", "Column Options"]]), createElement("span", createObj(ofArray([["className", "icon-text"], (elems = [createElement("span", createObj(Helpers_combineClasses("icon", toList(delay_1(() => iconProps))))), createElement("span", createObj(toList(delay_1(() => [["children", col_2.Name]]))))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))) : singleton_1(col_2.Name), delay_1(() => {
                let $keyZ75D5EE80;
                const matchValue = col_2.Filter;
                if (matchValue != null) {
                    const filter = matchValue;
                    return singleton_1(($keyZ75D5EE80 = (`${name}:${col_2.Id}:filter:${refresh}`), createElement(RenderFilter, {
                        key: $keyZ75D5EE80,
                        $key: $keyZ75D5EE80,
                        columnId: col_2.Id,
                        currentFilters: state_1.Filters,
                        filter: filter,
                        dispatch: dispatch,
                    })));
                }
                else {
                    return singleton_1(defaultOf());
                }
            }));
        }));
        return createElement("th", {
            children: reactApi_1.Children.toArray(Array.from(children)),
        });
    }, filter_3((col_1) => !FSharpSet__Contains(columnVisbility, col_1.Id), columns)), createElement("tr", {
        children: reactApi_1.Children.toArray(Array.from(children_2)),
    }))), createElement("thead", {
        children: reactApi_1.Children.toArray(Array.from(children_4)),
    })), (children_8 = mapIndexed((i_4, row) => {
        const renderedRow = rowRender(row);
        const cellMap = ofList_1(map_1((cell) => [cell.Id, cell], renderedRow.Cells), {
            Compare: comparePrimitives,
        });
        return createElement("tr", createObj(toList(delay_1(() => append_1(singleton_1(["key", renderedRow.Id]), delay_1(() => append_1(canClick ? append_1(singleton_1(["onClick", (e) => {
            onRowClick(e)(i_4);
        }]), delay_1(() => append_1(singleton_1(["onDoubleClick", onRowDoubleClick]), delay_1(() => (FSharpSet__Contains(state_1.SelectedIndex, i_4) ? singleton_1(op_PlusPlus(["className", "is-selected"], ["className", "is-clickable"])) : singleton_1(["className", "is-clickable"])))))) : empty_3(), delay_1(() => {
            let elems_2;
            return singleton_1((elems_2 = map((cell_1) => {
                const children_6 = singleton(defaultArg(map_2((c) => c.Render, FSharpMap__TryFind(cellMap, cell_1)), defaultOf()));
                return createElement("td", {
                    children: reactApi_1.Children.toArray(Array.from(children_6)),
                });
            }, visbileColumns), ["children", reactApi_1.Children.toArray(Array.from(elems_2))]));
        }))))))));
    }, state_1.Data), createElement("tbody", {
        children: reactApi_1.Children.toArray(Array.from(children_8)),
    })), (children_11 = ofArray([createElement("tr", {
        className: "totals",
        children: createElement("td", createObj(toList(delay_1(() => append_1(singleton_1(["colSpan", length(visbileColumns)]), delay_1(() => (state_1.IsTotalLoading ? singleton_1(["children", "Loading..."]) : (isEmpty(state_1.Data) ? singleton_1(["children", "No data available"]) : singleton_1(["children", `Showing ${System_Int32__Int32_ToLocaleString(state_1.Offset + 1)} - ${System_Int32__Int32_ToLocaleString(state_1.Offset + length(state_1.Data))} of ${System_Int32__Int32_ToLocaleString(state_1.Total)} results`]))))))))),
    }), createElement("tr", createObj(ofArray([["colSpan", length(visbileColumns)], (elems_7 = [createElement("td", createObj(ofArray([["colSpan", length(visbileColumns)], (elems_6 = [(elms = ofArray([createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", "<<"], ["onClick", (_arg_3) => {
        dispatch(new Msg$1(3, []));
    }], ["disabled", !State$1__get_CanFirst(state_1) ? true : state_1.IsLoading]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", "<"], ["onClick", (_arg_4) => {
        dispatch(new Msg$1(5, []));
    }], ["disabled", !State$1__get_CanPrevious(state_1) ? true : state_1.IsLoading]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", ">"], ["onClick", (_arg_5) => {
        dispatch(new Msg$1(4, []));
    }], ["disabled", !State$1__get_CanNext(state_1) ? true : state_1.IsLoading]])))), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", ">>"], ["onClick", (_arg_6) => {
        dispatch(new Msg$1(6, []));
    }], ["disabled", !State$1__get_CanLast(state_1) ? true : state_1.IsLoading]])))), (patternInput_6 = Helpers_extractClasses(ofArray([["defaultValue", fetchSize], ["onChange", (ev) => {
        iterate(patternInput_3[1], toArray(System_Int32__Int32_tryParse_Static_Z721C83C5(ev.target.value)));
    }], (elems_3 = map_1((size) => createElement("option", {
        children: `Show ${size}`,
        value: size,
    }), fetchOptions), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])), createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput_6[0]))], (elems_4 = [createElement("select", createObj(patternInput_6[1]))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))]), createElement("div", {
        className: "buttons",
        children: reactApi_1.Children.toArray(Array.from(elms)),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])))]), createElement("tfoot", {
        children: reactApi_1.Children.toArray(Array.from(children_11)),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])]))));
}

